var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.pageLoaded)?_c('v-layout',{style:({height: _vm.innerHeight + 'px'}),attrs:{"align-center":"","justify-center":"","column":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":50,"color":"primary"}}),_c('h1',{staticClass:"mt-2 subheading font-weight-bold primary--text"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }